const keys = {
  APROVACAO_COMPRA_GESTOR_COMPRAS: {
    key: 'APROVACAO_COMPRA_GESTOR_COMPRAS',
    description: 'Nova aprovação de compra solicitada',
    userRoles: ['ROLE_GESTOR_COMPRAS', 'ROLE_APROVADOR_COMPRAS'],
  },
  COMPRADOR_NOVA_REQUISICAO: {
    key: 'COMPRADOR_NOVA_REQUISICAO',
    description: 'Nova solicitação de compra criada',
    userRoles: ['ROLE_COMPRADOR'],
  },
  REQUISICAO_FINALIZADA: {
    key: 'REQUISICAO_FINALIZADA',
    description: 'Solicitação de compra finalizada',
    userRoles: ['ROLE_REQUISICAO'],
  },
  REQUISICAO_ATUALIZADA: {
    key: 'REQUISICAO_ATUALIZADA',
    description: 'Solicitação de compra atualizada',
    userRoles: ['ROLE_COMPRADOR'],
  },
  COMPRA_RECUSADA_PELO_FORNECEDOR_GESTAO: {
    key: 'COMPRA_RECUSADA_PELO_FORNECEDOR_GESTAO',
    description: 'Compra recusada pelo fornecedor',
    userRoles: ['ROLE_COMPRADOR'],
  },
};

const values = Object.keys(keys)
  .map(key => keys[key]);

export default {
  keys,
  values,
};
